export const KNOWLEDGE_CATEGORIES = [
  "Before Transplant",
  "During Transplant",
  "After Transplant",
  "Living Donation",
  "Organ Donation",
  "Costs & Financial Planning",
  "Patient Resources",
];

export const fmtArticleDate = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return isNaN(dt) ? String(d) : dt.toLocaleDateString("en-IN", { month: "short", year: "numeric" });
};
